import { backOfficeMicroservice } from './api-config';
import axios from 'axios';

// === ROLES ===
export const retrieveRoles = () => backOfficeMicroservice().get('/roles');
export const retrievePolicies = () => backOfficeMicroservice().get('/policies');
export const retrievePoliciesForOperator = () =>
  backOfficeMicroservice().get('/policies/forOperator');

export const createRole = (name, policies, operatorIds, providerIds) =>
  backOfficeMicroservice().post(`/roles/${name}`, {
    policyNames: policies,
    ...(operatorIds && {
      operatorIds,
    }),
    providerIds,
  });

export const setRolePolicy = (roleId, policies) =>
  backOfficeMicroservice().post(`/roles/${roleId}/setPolicies`, {
    policyNames: policies,
  });

export const retrieveRolePolicies = (roleId) =>
  backOfficeMicroservice().get(`/roles/${roleId}/withPolicies`);

export const deleteRole = (roleId) => backOfficeMicroservice().delete(`/roles/${roleId}`);

export const deleteRoles = (roleIds) => backOfficeMicroservice().post(`/roles/delete`, { roleIds });

// === USER ===
export const retrieveUsers = () => backOfficeMicroservice().get('/users');

export const createNewUser = (data) =>
  backOfficeMicroservice().post(`/users/${data.userName}/register`, {
    password: data.password,
    roleId: data.roleId,
  });

export const changeUserPassword = (data) =>
  backOfficeMicroservice().put(`/users/${data.userName}/changePassword `, {
    oldPassword: data.oldPassword,
    newPassword: data.newPassword,
  });

export const changeUserRole = (data) =>
  backOfficeMicroservice().post(`/users/${data.userName}/roles/${data?.roleId}/set`);

export const deleteUser = (userName) =>
  backOfficeMicroservice().delete(`/users/${userName}/delete`);

export const deleteUsers = (data) => backOfficeMicroservice().post(`/users/delete`, data);

// === External Games ===

export const retrieveExternalGames = (options) =>
  backOfficeMicroservice().get('external/games', {
    params: {
      ...options,
    },
  });

export const retrieveExternalGameData = (id) =>
  backOfficeMicroservice().get(`external/games/${id}`);

export const createExternalGame = (data) =>
  backOfficeMicroservice().post(`external/games/${data.gameId}`, data);

export const updateExternalGame = (data) =>
  backOfficeMicroservice().put(`external/games/${data.gameId}`, data);

export const removeExternalGame = (gameId) =>
  backOfficeMicroservice().delete(`external/games/${gameId}`);

// === GAMES ===
export const retrieveGames = (options) =>
  backOfficeMicroservice().get('games', {
    params: {
      ...options,
    },
  });

export const retrieveGamesShort = (options) =>
  backOfficeMicroservice().get('games/summaries', {
    params: {
      ...options,
    },
  });

export const retrieveGamesShortInfo = (options) =>
  backOfficeMicroservice().get('shortGameInfos', {
    params: {
      ...options,
    },
  });

export const retrieveClients = (options) =>
  backOfficeMicroservice().get('clients', {
    params: {
      ...options,
    },
  });

export const retrieveClientById = (id) => backOfficeMicroservice().get(`clients/${id}`);

export const createClient = (data) => backOfficeMicroservice().post('clients', data);

export const saveClient = (id, data) => backOfficeMicroservice().put(`clients/${id}`, data);

export const saveClientTestData = (id, data) =>
  backOfficeMicroservice().put(`clients/${id}/testData`, data);

export const createGame = (data) => backOfficeMicroservice().post('games', data);

export const retrieveGameById = (id) => backOfficeMicroservice().get(`games/${id}`);

export const importGame = (data) =>
  backOfficeMicroservice().post('games/import', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const analyzeImportGame = (data) =>
  backOfficeMicroservice().post('games/import/analyze', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const exportGame = (gameId, params) =>
  backOfficeMicroservice().get(`games/${gameId}/export`, {
    params,
    paramsSerializer: {
      serialize: (params) => {
        const searchParams = new URLSearchParams();
        params.operatorIds.forEach((id) => searchParams.append('operatorIds', id));
        if (params.includeClientHistoryPackage !== undefined) {
          searchParams.append('includeClientHistoryPackage', params.includeClientHistoryPackage);
        }
        return searchParams.toString();
      },
    },
    responseType: 'blob',
  });

export const retrieveCertInfoByGameId = (id) =>
  backOfficeMicroservice().get(`games/${id}/certInfo`);

export const retrieveActiveCertInfo = (gameEngineId, gameId) =>
  backOfficeMicroservice().get(`gameEngines/${gameEngineId}/games/${gameId}/info`);

export const retrieveGameOperators = (id) => backOfficeMicroservice().get(`games/${id}/operators`);

export const retrieveGameOperatorsLimits = (id, operatorId) =>
  backOfficeMicroservice().get(`games/${id}/operators/${operatorId}/limits`);

export const deleteGameOperatorsLimits = (limitId, operatorId) =>
  backOfficeMicroservice().delete(`limits/${limitId}?operatorId=${operatorId}`);

export const createGameOperatorsLimits = (
  id,
  operatorId,
  data,
  _,
  market,
  country,
  currentType,
  isPreview = false
) =>
  backOfficeMicroservice().post(
    `games/${id}/operators/${operatorId}/limits${isPreview ? '/preview?' : '?'}${currentType !== 'Default' ? (currentType === 'Market' ? `market=${market}` : `country=${country}`) : ''}`,
    data
  );

export const updateGameOperatorsLimits = (
  _,
  operatorId,
  data,
  limitId,
  market,
  country,
  currentType,
  isPreview = false
) =>
  backOfficeMicroservice().put(
    `limits/${limitId}${isPreview ? '/preview?' : '?'}operatorId=${operatorId}`,
    data
  );

export const saveGameEngineConfig = (id, data) =>
  backOfficeMicroservice().put(`games/${id}/engineConfig`, data);

export const saveGameEventConfiguration = (id, data) =>
  backOfficeMicroservice().put(`games/${id}/eventConfiguration`, data);

export const saveGameConfig = (id, data) =>
  backOfficeMicroservice().put(`games/${id}/config`, data);

export const updateGameName = (id, name) =>
  backOfficeMicroservice().put(`games/${id}/name`, {
    name,
  });

export const toggleGameStatus = (gameId, status) =>
  backOfficeMicroservice().put(`games/${gameId}/${status}`);

export const saveGameOperator = (
  id,
  operatorId,
  data = {
    isActive: true,
  }
) => backOfficeMicroservice().post(`games/${id}/operators/${operatorId}`, data);

export const updateGameOperator = (id, operatorId, data) =>
  backOfficeMicroservice().put(`games/${id}/operators/${operatorId}`, data);

export const toggleGameOperator = (gameId, operatorId, type) =>
  backOfficeMicroservice().put(
    `games/${gameId}/operators/${operatorId}/${type ? 'enable' : 'disable'}`
  );

export const updateGameFeatures = (gameId, features) =>
  backOfficeMicroservice().put(`games/${gameId}/features`, features);

export const propagateOperators = (gameId, data) =>
  backOfficeMicroservice().post(`games/${gameId}/propagateOperators`, data);

export const inheritOperators = (gameId) =>
  backOfficeMicroservice().post(`games/${gameId}/inheritOperators`);

// === OPERATORS ===
export const retrieveOperators = (options) =>
  backOfficeMicroservice().get('operators', {
    params: {
      ...options,
    },
  });

export const retrieveOperatorById = (id) => backOfficeMicroservice().get(`operators/${id}`);

export const createOperator = (data) => backOfficeMicroservice().post('operators', data);
export const updateOperator = (data) => backOfficeMicroservice().put('operators', data);

// === Packages ===

export const retrievePackages = (options) =>
  backOfficeMicroservice().get('packages', {
    params: {
      ...options,
    },
  });

export const retrievePackageById = (id) => backOfficeMicroservice().get(`packages/${id}`);
export const createPackage = (data) => backOfficeMicroservice().post('packages', data);
export const updatePackage = (id, data) => backOfficeMicroservice().put(`packages/${id}`, data);
export const deletePackage = (id) => backOfficeMicroservice().delete(`packages/${id}`);
export const downloadPackage = (id) =>
  backOfficeMicroservice().get(`packages/${id}/downloadzip`, {
    responseType: 'blob',
  });

export const retrieveUploadUrl = () =>
  backOfficeMicroservice().get('packages/generatePreSignedUrl');

// === ENGINES ===
export const retrieveEngines = () => backOfficeMicroservice().get('/engines/detailed');

export const createEngine = (data) => backOfficeMicroservice().post('engines', data);

export const uploadZipToS3Bucket = (url, data) =>
  axios({
    method: 'put',
    url,
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    data: data,
  });

export const getS3UrlData = (url) =>
  axios({
    method: 'get',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const downloadS3UrlData = (url) =>
  axios({
    method: 'get',
    url,
    headers: {
      'Content-Type': 'application/octet-stream',
    },
  });

// LP
export const retrieveLP = (options) =>
  backOfficeMicroservice().get('liquidityPools', {
    params: {
      ...options,
    },
  });

export const createLP = (data) => backOfficeMicroservice().post('liquidityPools', data);

// JACKPOTS
export const retrieveJackpots = (options) =>
  backOfficeMicroservice().get('jackpots', {
    params: {
      ...options,
    },
  });
export const createJackpot = (data) => backOfficeMicroservice().post('jackpots', data);
export const retrieveJackpotById = (id) => backOfficeMicroservice().get(`jackpots/${id}`);

// GROUPS
export const retrieveGroups = () => backOfficeMicroservice().get('jackpotGroups');
export const retrieveGroupsShort = () => backOfficeMicroservice().get('jackpotGroups/shortInfo');
export const retrieveGroupById = (id) => backOfficeMicroservice().get(`jackpotGroups/${id}`);
export const createGroup = (data) => backOfficeMicroservice().post('jackpotGroups', data);

//DICTIONARIES
export const getDictionaryByType = (type) => backOfficeMicroservice().get(`dictionaries/${type}`);

export const getDictionaries = () => backOfficeMicroservice().get('dictionaries');

export const updateDictionary = (type, values) =>
  backOfficeMicroservice().put(`dictionaries/${type}`, { values });

export const createDictionary = (type, values) =>
  backOfficeMicroservice().post(`dictionaries/${type}`, { values });
export const getEnginesList = () => backOfficeMicroservice().get(`engines`);
export const getOperatorsList = () => backOfficeMicroservice().get(`operators`);

//LOADER
export const retrieveLoaderTree = () =>
  backOfficeMicroservice().get('bootloader/getLoaderFilesTree');
export const retrieveLoaderHistory = () => backOfficeMicroservice().get('bootloader/getHistory');

export const downloadLoaderZIP = (id) =>
  backOfficeMicroservice().get(`bootloader/${id}/downloadzip`, {
    responseType: 'blob',
  });

export const revertLoader = (id) => backOfficeMicroservice().put(`bootloader/${id}/revert`);

export const updateLoaderComment = (id, comment) =>
  backOfficeMicroservice().put(`bootloader/${id}/updatecomment`, { comment });

export const uploadZipLoader = (data) =>
  backOfficeMicroservice().post(`bootloader`, data, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
  });

//CUSTOM PAY TABLE

export const retrieveCustomPayTable = (gameId) =>
  backOfficeMicroservice().get(`games/${gameId}/customPayTable`);

export const updateCustomPayTable = (gameId, data) =>
  backOfficeMicroservice().post(`games/${gameId}/customPayTable`, data);

//GAME RULES

export const retrieveGameRules = (gameId) =>
  backOfficeMicroservice().get(`games/${gameId}/gameRules`);

export const retrieveGameRuleFile = (gameId, path) =>
  backOfficeMicroservice().get(`games/${gameId}/gameRules/file`, { params: { path } });

export const updateGameRuleFile = (gameId, data) =>
  backOfficeMicroservice().post(`games/${gameId}/gameRules/file`, data);

export const retrieveGameRulesBundle = (gameId) =>
  backOfficeMicroservice().get(`games/${gameId}/gameRules/bundle`);

export const generateGameRules = (gameId, data) =>
  backOfficeMicroservice().post(`games/${gameId}/gameRules/generate`, data);

export const publishGameRules = (gameId, data) =>
  backOfficeMicroservice().post(`games/${gameId}/gameRules/publish`, data);

//CERT INFO

export const updateGameCertInfo = (id, data) =>
  backOfficeMicroservice().put(`games/${id}/certInfo`, data);

export const createGameCertInfo = (id, data) =>
  backOfficeMicroservice().post(`games/${id}/certInfo`, data);

export const downloadCertInfoZIP = (gameEngineId, gameId) =>
  backOfficeMicroservice().get(`gameEngines/${gameEngineId}/games/${gameId}/downloadCertInfo`, {
    responseType: 'blob',
  });

//GAME SESSIONS

export const getGameSessionList = (params, { page, perPage } = {}) =>
  backOfficeMicroservice().get('gameSessions', {
    params,
    headers: {
      ...(page != null && { 'X-Page': page }),
      ...(perPage != null && { 'X-Per-Page': perPage }),
    },
  });

export const settleGameSession = ({ operatorId, gameId, operatorPlayerId }) =>
  backOfficeMicroservice().post(
    `operators/${operatorId}/games/${gameId}/settleGameSession?OperatorPlayerId=${operatorPlayerId}`
  );

export const cancelGameSession = ({ operatorId, gameId, operatorPlayerId }) =>
  backOfficeMicroservice().post(
    `operators/${operatorId}/games/${gameId}/cancelGameSession?OperatorPlayerId=${operatorPlayerId}`
  );

//TESTING

export const retrieveGamesForTest = (params) =>
  backOfficeMicroservice().get('gamesForTest', {
    params,
  });

// RTP Verification Form Builder — per-engine form schemas
export const retrieveRtpTestForms = () => backOfficeMicroservice().get('rtpTestForms');

export const retrieveRtpTestForm = (engineId) =>
  backOfficeMicroservice().get(`rtpTestForms/${engineId}`);

export const saveRtpTestForm = (engineId, fields) =>
  backOfficeMicroservice().put(`rtpTestForms/${engineId}`, { fields });

export const deleteRtpTestForm = (engineId) =>
  backOfficeMicroservice().delete(`rtpTestForms/${engineId}`);

export const startTest = (testSettings, comment, gameId) =>
  backOfficeMicroservice().post(`games/${gameId}/start`, {
    testSettings,
    comment,
  });

export const approveTest = (testId) => backOfficeMicroservice().post(`tests/${testId}/approve`);

export const stopTest = (gameId) => backOfficeMicroservice().post(`tests/${gameId}/stop`);

export const retrieveGameTests = (gameId) =>
  backOfficeMicroservice().get(`games/${gameId}/results`);

export const retrieveTestResult = (testId) =>
  backOfficeMicroservice().get(`tests/${testId}/resultUrl`);

//Load Testing

export const retrieveLoadTestingList = (params) =>
  backOfficeMicroservice().get('loadTests', {
    params,
  });

export const stopLoadTest = (id) => backOfficeMicroservice().post(`loadTests/${id}/stop`);

export const startLoadTest = (data) => backOfficeMicroservice().post('startLoadTest', data);

export const retrieveLoadTestDetails = (id) =>
  backOfficeMicroservice().get(`loadTests/${id}/result`);

export const retrieveGameLoadTestStatus = (gameId) =>
  backOfficeMicroservice().get(`games/${gameId}/loadTestStatus`);

export const updateLoadTestResultStatus = (id, resultStatus) =>
  backOfficeMicroservice().put(`loadTests/${id}/resultStatus`, { resultStatus });

//Game Simulation

export const retrieveSimulations = ({ page = 1, perPage = 10 } = {}) =>
  backOfficeMicroservice().get('simulations', {
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

export const stopSimulation = (id) => backOfficeMicroservice().post(`simulations/${id}/stop`);

export const startSimulation = (data) => backOfficeMicroservice().post('simulations/start', data);

// Game Round History
export const getGameRoundHistoryList = (params, { page = 1, perPage = 10 } = {}) =>
  backOfficeMicroservice().get('historymanager/data', {
    params,
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

export const getHistoryManager20List = (params, { page = 1, perPage = 10 } = {}) =>
  backOfficeMicroservice().get('historymanager/v2/gameRounds', {
    params,
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

export const getHistoryManager20GameSessions = (params, { page = 1, perPage = 10 } = {}) =>
  backOfficeMicroservice().get('historymanager/v2/gameSessions', {
    params,
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

export const getHistoryManager20GameSessionsCount = (params) =>
  backOfficeMicroservice().get('historymanager/v2/gameSessions/count', { params });

export const getHistoryManager20Rounds = (gameRoundId) =>
  backOfficeMicroservice().get(`historymanager/v2/gameRounds/${gameRoundId}/rounds`);

export const getHistoryManager20Report = (type, params) =>
  backOfficeMicroservice().get(`historymanager/v2/report/${type}`, {
    params,
    responseType: 'blob',
  });

export const getGameRoundHistoryUrl = ({ operatorId, gameId, gameRoundId, operatorPlayerId }) =>
  backOfficeMicroservice().get(
    `operators/${operatorId}/games/${gameId}/gameRounds/${gameRoundId}/players/${operatorPlayerId}/historyUrl`
  );

export const getGameRoundCapture = ({ operatorId, gameId, gameRoundId, operatorPlayerId }) =>
  backOfficeMicroservice().get(
    `operators/${operatorId}/games/${gameId}/gameRounds/${gameRoundId}/players/${operatorPlayerId}/capture`,
    { responseType: 'blob' }
  );

//BONUSES

export const getBonusesList = (params) => backOfficeMicroservice().post('bonusInfos', params);

export const createBonus = (operatorId, bonusId, data) =>
  backOfficeMicroservice().post(`operators/${operatorId}/bonuses/${bonusId}/create`, data);

export const assignBonus = (operatorId, bonusId, operatorPlayerId) =>
  backOfficeMicroservice().post(
    `operators/${operatorId}/bonuses/${bonusId}/players/${operatorPlayerId}/assign`
  );

export const getUserBonusesList = (params) =>
  backOfficeMicroservice().post('userBonusInfos', params);

//Select Page Configuration

export const uploadSelectPageZip = (data) =>
  backOfficeMicroservice().post('uploadSelectPage', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const downloadSelectPage = () =>
  backOfficeMicroservice().get('downloadSelectPage', {
    responseType: 'blob',
  });

//Thresholds

export const getThresholds = () => backOfficeMicroservice().get('loadTestsThreasholds');
export const updateThresholds = (data) =>
  backOfficeMicroservice().put('loadTestsThreasholds', data);

//Provider Integration Callback

export const sendProviderIntegrationCallback = (operatorId, data) =>
  backOfficeMicroservice().post(`operators/${operatorId}/callback`, data);

// === AUDIT ===

export const getAuditEventsList = (params, { page = 1, perPage = 25 } = {}) =>
  backOfficeMicroservice().post('auditEvents', params, {
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

export const getAuditEvent = (id) => backOfficeMicroservice().get(`auditEvents/${id}`);

export const getAuditedEventsList = () => backOfficeMicroservice().get('auditEvents/events');

// === GAME EVENT LOGGER ===

export const getGameEventsList = (params, { page = 1, perPage = 20 } = {}) =>
  backOfficeMicroservice().get('gameEvents', {
    params,
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

// === INCIDENTS ===

export const getIncidentsList = (params, { page = 1, perPage = 20 } = {}) =>
  backOfficeMicroservice().get('incidents', {
    params,
    headers: { 'X-Page': page, 'X-Per-Page': perPage },
  });

export const getIncident = (incidentId) => backOfficeMicroservice().get(`incidents/${incidentId}`);

export const getIncidentDocument = (incidentId, documentId) =>
  backOfficeMicroservice().get(`incidents/${incidentId}/documents/${documentId}`);

export const resolveIncident = (incidentId, gameRoundId) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/resolve`, { gameRoundId });

export const analyzeIncident = (incidentId) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/analyze`);

export const arbitrateIncident = (incidentId, category) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/arbitrate`, null, {
    params: category ? { category } : undefined,
  });

export const editIncidentDraft = (incidentId, letter) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/draft`, { letter });

export const reviewIncident = (incidentId, body) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/review`, body);

export const clarifyIncident = (incidentId, question, attachments) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/clarify`, { question, attachments });

export const closeIncident = (incidentId, reason) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/close`, null, {
    params: reason ? { reason } : undefined,
  });

export const reopenIncident = (incidentId) =>
  backOfficeMicroservice().post(`incidents/${incidentId}/reopen`);
